<template>
  <div id="app">
	<router-view :key="$route.fullPath" />
  </div>
</template>

<script>
// vuex
import { mapMutations } from 'vuex'
export default {
  mounted() {
	  // 给所有a标签设置不可点击
	  let a = document.querySelectorAll('a');
	  for(let i=0; i<a.length;i++) {
		if(!a[i].getAttribute('href')){
			a[i].setAttribute('href', 'javascript:;');
		}
	  }
  },
  created() {
	  // 调用获取公共属性方法
	  if(localStorage.getItem('member')) {
		  this.changeState({
			  member: JSON.parse(localStorage.getItem('member'))
		  })
	  }
  },
  
  methods: {
	  // vuex
	  ...mapMutations(['changeState'])
  }
}
</script>

<style lang="less">
.el-pagination.is-background .el-pager li:not(.disabled).active{
	background: #0BA29B !important;
}
</style>
